import { render } from "./About.vue?vue&type=template&id=0ce321b2"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\TEMPLATES\\nuron-nft-marketplace-vue-js-template\\nuron-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__